/* eslint-disable-next-line no-unused-vars */
/* global __webpack_public_path__ */
if (window.JS_BASE_URL) {
  __webpack_public_path__ = window.JS_BASE_URL;
}
